import { ArrowUpDown } from "lucide-react";
import { Button } from "./Button";

const TableHeaderSortingButton = ({ column, headerText }) => {
  return (
    <Button
      variant="ghost"
      onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
    >
      {headerText}
      <ArrowUpDown className="ml-2 h-4 w-4" />
    </Button>
  );
};

export default TableHeaderSortingButton;
